//  у автора BookList
<template>
  <v-container class="grey lighten-3"  fluid>
    
    <!-- фильтр-поиск -->
    <v-flex xs12 sm10 md8 offset-sm1 offset-md2>

     

      <v-container fluid>
        <v-row no-gutters >

          <v-flex >
            <v-text-field label="Поиск по названию статьи:" v-model="searchTerm"></v-text-field>
          </v-flex>

          <v-btn 
            v-if="isUserAuthentificated"
            :to="{name:'createnews'}"
            fixed
            top-1
            right
            fab
            dark
            large
            color="purple"
            class="mr-3"
          > 
            <v-icon dark size="40">mdi mdi-plus</v-icon>
          </v-btn>

        </v-row>
          
      </v-container>
    </v-flex>

    <!-- Блоки с news -->
    <v-flex xs12 sm10 md10 offset-sm1 offset-md1>
      

      <v-row >
        <v-col
          v-for="news in filteredNews" 
          :key="news.id"  
          color="teal lighten-2"
          cols="12"
          class="mb-5"
        >
        <!-- md="3"
        xs="12" 
        sm="6" -->


        <!-- запрос информации из DogListItem.vue  для заполнения  карточек -->
          <mercy :news="news">           
          </mercy>

        </v-col>
      </v-row>
    </v-flex>
  </v-container>
</template>

<script>
import Mercy from './MercyListItem' 
export default {
  data() {
    return {
      searchTerm: null,
    }
  },

  computed: {
    mercy() {
      return this.$store.getters.getNews
    },

    filteredNews() {
      let mercy = this.mercy
      if (this.searchTerm) 
        mercy = mercy.filter(d => 
          d.newsTitle.toLowerCase().indexOf(this.searchTerm.toLowerCase())>=0)
          //  mercy = mercy.filter(d => 
          // d.newsTitle.toLowerCase().indexOf(this.searchTerm.toLowerCase()) >= 0
          // || d.description.toLowerCase().indexOf(this.searchTerm.toLowerCase()) >= 0)
      return mercy
    },

    isUserAuthentificated() {
        return this.$store.getters.isUserAuthentificated
     },
    
  },
  

  components: {
    // подключение компонента DogListItem.vue для заполнения  карточек 
    Mercy
  }
}
</script>

<style scoped>
#animalCard {
  /* min-height: 350px; */
  color: royalblue 
}

/* кнопка на карточке на весь контейнер */
.v-card__actions {
  padding: 0px;
}

/* отступ слева от фото */
.v-application .ml-1 {
  margin-left: -1px!important;
}

/* отображение текста в карточке не шире 3-х строк + ... */
#subtitleText {
  height: calc(24px * 2); /* не стал писать 75px, чтобы показать, что максимум по высоте на 3 строки выделяю блок */
  padding-top: 10px;
  margin-bottom: 10px;
  overflow: hidden;
  line-height: 20px; /* каждая строка будет по высоте 25px, чтобы я точно мог установить высоту блока (это чисто визуально, ни на что не влияет) */
  display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
</style>
